/* ==========================================================================
   RW Forms — field helpers (loaded before rwf-core.js).
   Pure helpers + widget wiring: region lists, phone/email/zip rules, choice
   chips & cards, multi-select dropdowns, file inputs, character counters and
   the country-driven address block. The engine (rwf-core.js) owns state.
   ========================================================================== */
(function () {
  'use strict';
  var RWF = (window.RWF = window.RWF || {});

  var US = [
    ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'], ['CA', 'California'],
    ['CO', 'Colorado'], ['CT', 'Connecticut'], ['DE', 'Delaware'], ['DC', 'District of Columbia'],
    ['FL', 'Florida'], ['GA', 'Georgia'], ['HI', 'Hawaii'], ['ID', 'Idaho'], ['IL', 'Illinois'],
    ['IN', 'Indiana'], ['IA', 'Iowa'], ['KS', 'Kansas'], ['KY', 'Kentucky'], ['LA', 'Louisiana'],
    ['ME', 'Maine'], ['MD', 'Maryland'], ['MA', 'Massachusetts'], ['MI', 'Michigan'], ['MN', 'Minnesota'],
    ['MS', 'Mississippi'], ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'], ['NV', 'Nevada'],
    ['NH', 'New Hampshire'], ['NJ', 'New Jersey'], ['NM', 'New Mexico'], ['NY', 'New York'],
    ['NC', 'North Carolina'], ['ND', 'North Dakota'], ['OH', 'Ohio'], ['OK', 'Oklahoma'], ['OR', 'Oregon'],
    ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'], ['SC', 'South Carolina'], ['SD', 'South Dakota'],
    ['TN', 'Tennessee'], ['TX', 'Texas'], ['UT', 'Utah'], ['VT', 'Vermont'], ['VA', 'Virginia'],
    ['WA', 'Washington'], ['WV', 'West Virginia'], ['WI', 'Wisconsin'], ['WY', 'Wyoming'], ['PR', 'Puerto Rico']
  ];
  var CA = [
    ['AB', 'Alberta'], ['BC', 'British Columbia'], ['MB', 'Manitoba'], ['NB', 'New Brunswick'],
    ['NL', 'Newfoundland and Labrador'], ['NS', 'Nova Scotia'], ['NT', 'Northwest Territories'],
    ['NU', 'Nunavut'], ['ON', 'Ontario'], ['PE', 'Prince Edward Island'], ['QC', 'Quebec'],
    ['SK', 'Saskatchewan'], ['YT', 'Yukon']
  ];

  /* Country-driven labels/regexes shared by every address block. The tax and
     exempt fields are used by B2B forms (e.g. distributor application) that
     ask for a tax ID and an exemption list alongside the address. */
  var LOC = {
    US: {
      region: 'State', list: US, zip: 'ZIP code', zipPh: '75001', zipRe: /^\d{5}(-\d{4})?$/, name: 'United States',
      taxLabel: 'Federal Tax ID (EIN)', taxPh: '12-3456789', taxRe: /^\d{2}-\d{7}$/, exemptLabel: 'States where you’re exempt'
    },
    CA: {
      region: 'Province', list: CA, zip: 'Postal code', zipPh: 'A1A 1A1', zipRe: /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/, name: 'Canada',
      taxLabel: 'Business Number (BN)', taxPh: '123456789', taxRe: null, exemptLabel: 'Provinces where you’re exempt'
    },
    other: {
      region: 'State / region', list: null, zip: 'Postal code', zipPh: '', zipRe: null, name: 'Other country',
      taxLabel: 'Business tax / VAT number', taxPh: '', taxRe: null, exemptLabel: 'Regions where you’re exempt'
    }
  };

  RWF.data = { US: US, CA: CA, LOC: LOC };
  RWF.loc = function (country) { return LOC[country] || LOC.US; };
  RWF.EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  RWF.URL = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(\/\S*)?$/i;
  RWF.PHONE_MSG = 'Enter a valid 10-digit US/Canada number, or start with + and the country code.';
  RWF.EMAIL_MSG = 'Enter a valid email address, like name@example.com.';

  RWF.phoneOk = function (val) {
    var s = String(val || '').trim();
    if (s.charAt(0) === '+') {
      var n = s.replace(/\D/g, '').length;
      return n >= 8 && n <= 15;
    }
    var d = s.replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return /^[2-9]\d{2}[2-9]\d{6}$/.test(d);
  };

  /* A number can satisfy phoneOk's format check and still obviously be a
     placeholder (1111111111, 1234567890, ...) rather than a real one.
     Flagged in the review/email copy, not blocked -- these aren't invalid
     enough to refuse, just worth a second look by whoever reads the email. */
  RWF.phoneLooksFake = function (val) {
    var s = String(val || '').trim();
    if (s.charAt(0) === '+') return false;
    var d = s.replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length !== 10) return false;
    if (/^(\d)\1{9}$/.test(d)) return true;
    return '01234567890123456789'.indexOf(d) > -1 || '98765432109876543210'.indexOf(d) > -1;
  };

  RWF.fmtPhone = function (val) {
    var s = String(val || '');
    if (s.trim().charAt(0) === '+') return s;
    var d = s.replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length > 10 || !d.length) return s;
    if (d.length < 4) return d;
    if (d.length < 7) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  };

  RWF.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  RWF.today = function () {
    return new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  };

  /* ---------- Choice chips / cards: [data-rwf-choice="name"] ---------- */
  RWF.wireChoice = function (box, onPick) {
    var multi = box.hasAttribute('data-multi');
    box.setAttribute('role', multi ? 'group' : 'radiogroup');
    box.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-value]');
      if (!btn || !box.contains(btn) || btn.disabled) return;
      onPick(btn.getAttribute('data-value'), multi);
    });
  };

  RWF.paintChoice = function (box, value) {
    var multi = box.hasAttribute('data-multi');
    box.querySelectorAll('[data-value]').forEach(function (btn) {
      var v = btn.getAttribute('data-value');
      var on = multi ? (value || []).indexOf(v) > -1 : value === v;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (!multi) btn.setAttribute('role', 'radio');
      if (!multi) btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.type = 'button';
    });
  };

  /* ---------- Multi-select dropdown: [data-rwf-ms="name"] with [data-opt] children ---------- */
  var CHEVRON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  RWF.wireMulti = function (box, onToggle) {
    var opts = [];
    box.querySelectorAll('[data-opt]').forEach(function (o) {
      opts.push({ value: o.getAttribute('data-value') || o.textContent.trim(), label: o.textContent.trim() });
      o.remove();
    });
    box._opts = opts;
    var ph = box.getAttribute('data-placeholder') || 'Select all that apply';
    var id = 'rwf-ms-' + box.getAttribute('data-rwf-ms');
    box.classList.add('rwf-ms');
    box.innerHTML =
      '<div class="rwf-msfield"><button type="button" class="rwf-mstog" aria-haspopup="listbox" aria-expanded="false" aria-controls="' + id + '">' +
      '<span class="rwf-mstog__ph">' + RWF.esc(ph) + '</span>' + CHEVRON + '</button><span class="rwf-mstags"></span></div>' +
      '<div class="rwf-panel" id="' + id + '" role="listbox" aria-multiselectable="true" hidden>' +
      opts.map(function (o) {
        return '<label class="rwf-opt"><input type="checkbox" value="' + RWF.esc(o.value) + '"><span>' + RWF.esc(o.label) + '</span></label>';
      }).join('') + '</div>';
    var tog = box.querySelector('.rwf-mstog');
    var panel = box.querySelector('.rwf-panel');
    function setOpen(open) { panel.hidden = !open; tog.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    tog.addEventListener('click', function () { setOpen(panel.hidden); });
    panel.addEventListener('change', function (e) { if (e.target.value) onToggle(e.target.value, e.target.checked); });
    box.addEventListener('click', function (e) {
      var x = e.target.closest('[data-remove]');
      if (x) { e.stopPropagation(); onToggle(x.getAttribute('data-remove'), false); }
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) setOpen(false); });
    box.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setOpen(false); tog.focus(); } });
  };

  RWF.paintMulti = function (box, values) {
    values = values || [];
    var byVal = {};
    (box._opts || []).forEach(function (o) { byVal[o.value] = o.label; });
    box.querySelectorAll('.rwf-panel input').forEach(function (i) { i.checked = values.indexOf(i.value) > -1; });
    box.querySelector('.rwf-mstags').innerHTML = values.map(function (v) {
      return '<span class="rwf-tagx">' + RWF.esc(byVal[v] || v) +
        '<button type="button" data-remove="' + RWF.esc(v) + '" aria-label="Remove ' + RWF.esc(byVal[v] || v) + '">×</button></span>';
    }).join('');
    box.querySelector('.rwf-msfield').classList.toggle('has-tags', values.length > 0);
  };

  /* Rebuilds a multi-select's option list at runtime (e.g. a country-driven
     region list). The existing DOM node and its listeners are kept; only the
     panel's options are replaced. Selected values are repainted separately
     via RWF.paintMulti once the caller decides what should stay checked. */
  RWF.setMsOptions = function (box, opts) {
    box._opts = opts;
    var panel = box.querySelector('.rwf-panel');
    if (!panel) return;
    panel.innerHTML = opts.map(function (o) {
      return '<label class="rwf-opt"><input type="checkbox" value="' + RWF.esc(o.value) + '"><span>' + RWF.esc(o.label) + '</span></label>';
    }).join('');
  };

  RWF.multiLabels = function (box, values) {
    var byVal = {};
    (box._opts || []).forEach(function (o) { byVal[o.value] = o.label; });
    return (values || []).map(function (v) { return byVal[v] || v; });
  };

  /* ---------- File inputs: validate type/size/count, list chosen files ---------- */
  RWF.checkFiles = function (input) {
    var max = parseFloat(input.getAttribute('data-max-mb') || '10') * 1024 * 1024;
    var maxFiles = parseInt(input.getAttribute('data-max-files') || '5', 10);
    var accept = (input.getAttribute('accept') || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var bad = '';
    if (input.files && input.files.length > maxFiles) bad = 'Choose up to ' + maxFiles + ' files.';
    Array.prototype.forEach.call(input.files || [], function (f) {
      if (bad) return;
      var ext = '.' + f.name.split('.').pop().toLowerCase();
      var typeOk = !accept.length || accept.some(function (a) {
        return a === ext || a === f.type || (a.slice(-2) === '/*' && f.type.indexOf(a.slice(0, -1)) === 0);
      });
      if (!typeOk) bad = f.name + ' is not an accepted file type.';
      else if (f.size > max) bad = f.name + ' is larger than ' + input.getAttribute('data-max-mb') + ' MB.';
    });
    return bad;
  };

  /* Removes one file (by index) from a file input's current selection,
     rebuilding the FileList via DataTransfer since FileList itself is
     read-only -- there's no other way to drop a single file. */
  RWF.removeFile = function (input, index) {
    var dt = new DataTransfer();
    Array.prototype.forEach.call(input.files || [], function (f, i) { if (i !== index) dt.items.add(f); });
    input.files = dt.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  RWF.paintFiles = function (input) {
    var list = input.parentNode.querySelector('.rwf-file__list');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'rwf-file__list';
      input.parentNode.appendChild(list);
    }
    list.innerHTML = Array.prototype.map.call(input.files || [], function (f, i) {
      return '<li><span>' + RWF.esc(f.name) + ' · ' + Math.max(1, Math.round(f.size / 1024)) + ' KB</span>' +
        '<button type="button" class="rwf-file__remove" data-idx="' + i + '" aria-label="Remove ' + RWF.esc(f.name) + '">Remove</button></li>';
    }).join('');
  };

  /* ---------- Character counter: [data-counter] on input/textarea with maxlength ---------- */
  RWF.paintCounter = function (el) {
    var max = parseInt(el.getAttribute('data-counter') || el.getAttribute('maxlength'), 10);
    var c = el.parentNode.querySelector('.rwf-count');
    if (!c) {
      c = document.createElement('span');
      c.className = 'rwf-count';
      c.setAttribute('aria-live', 'polite');
      el.insertAdjacentElement('afterend', c);
    }
    var n = (el.value || '').length;
    c.textContent = n + ' / ' + max;
    c.classList.toggle('is-over', n > max);
  };

  /* ---------- Address block: country-driven labels, lists, placeholders ---------- */
  RWF.paintAddress = function (root, countryName, country) {
    var L = RWF.loc(country);
    root.querySelectorAll('[data-rwf-country-of="' + countryName + '"]').forEach(function (el) {
      var kind = el.getAttribute('data-rwf-addr');
      if (kind === 'region-label') el.textContent = L.region;
      if (kind === 'zip-label') el.textContent = L.zip;
      if (kind === 'zip') el.setAttribute('placeholder', L.zipPh);
      if (kind === 'tax-label') el.textContent = L.taxLabel;
      if (kind === 'tax') el.setAttribute('placeholder', L.taxPh);
      if (kind === 'exempt-label') el.textContent = L.exemptLabel;
      if (kind === 'region' && el.getAttribute('data-for') !== country) {
        var cur = el.value;
        el.innerHTML = '<option value="">Select ' + L.region.toLowerCase() + '</option>' +
          (L.list || []).map(function (s) { return '<option value="' + s[0] + '">' + RWF.esc(s[1]) + '</option>'; }).join('');
        el.setAttribute('data-for', country);
        el.value = cur;
      }
    });
  };
})();
